module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Map/Marker1-d96d17fdb2ff7d8b9596de8f9330d815.svg";